import * as React from "react";
import { gql, useQuery } from "@apollo/client";
import {
  ViewCommunityQueryQuery,
  ViewCommunityQueryQueryVariables
} from "../../schemaTypes";

export const viewCommunityQuery = gql`
  query ViewCommunityQuery($id: String!) {
    viewCommunity(id: $id) {
      id
      name
      alias
      logoUrl
      colorCode
      createdBy{
        id
        role
        admin {
          id
          shortId
          level
          firstname
          lastname
          email
        }
      }
      createdAt
      updatedAt
      isArchive
    }
  }
`;

export interface WithViewCommunity {
  community: ViewCommunityQueryQuery['viewCommunity'] | null;
  loading: boolean;
}

interface Props {
  communityId: string;
  children: (data: WithViewCommunity) => React.ReactElement | null;
}

export const ViewCommunity: React.FC<Props> = ({ communityId, children }) => {
  const { data, loading } = useQuery<
    ViewCommunityQueryQuery, 
    ViewCommunityQueryQueryVariables
  >
  (viewCommunityQuery, {
    variables: { id: communityId }
  });

  let community: ViewCommunityQueryQuery['viewCommunity'] | null = null;
  if (data && data.viewCommunity) {
    community = data.viewCommunity;
  }

  return children({
    community,
    loading
  });
};